<template>
  <nav class="breadcrumb" aria-label="breadcrumbs">
    <ul>
      <li><router-link to="/encyclopedia">Encyclopedia</router-link></li>
      <li
        v-for="segment in segments"
        :key="segment.link"
        :class="`${segment.active ? 'is-active' : ''}`"
      >
        <router-link :to="`/encyclopedia/${segment.link}`">{{ segment.name }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'breadcrumb',
  computed: {
    ...mapState('encyclopedia', ['categories', 'achievement', 'skill', 'location', 'giant', 'upgrade', 'item', 'inhabitant']),
    entity() {
      const segments = this.getUrlSegments();

      if (!segments[2]) {
        return null;
      }

      switch (segments[2]) {
        case 'skills':
          return this.skill;

        case 'achievements':
          return this.achievement;

        case 'locations':
          return this.location;

        case 'giants':
          return this.giant;

        case 'upgrades':
          return this.upgrade;

        case 'items':
          return this.item;

        case 'inhabitants':
          return this.inhabitant;

        default:
          return null;
      }
    },
    segments() {
      const segments = this.getUrlSegments();
      const items = [];

      if (segments[2] && this.categories[segments[2]]) {
        items.push({
          link: segments[2],
          name: this.categories[segments[2]].name,
          active: !segments[3],
        });
      }

      if (segments[3] && this.categories[segments[2]]) {
        items.push({
          link: `${segments[2]}/${segments[3]}`,
          name: this.categories[segments[2]].categories.find((category) => category.id === segments[3]).name,
          active: !segments[4],
        });
      }

      if (segments[4] && this.entity) {
        items.push({
          link: `${segments[2]}/${segments[3]}/${segments[4]}`,
          name: this.entity.display_name || this.entity.name || this.entity.label,
          active: true,
        });
      }

      return items;
    },
  },
  methods: {
    getUrlSegments() {
      return this.$route.path.split('/');
    },
  },
};
</script>
